/**
 * D-356 / D-540: Theme manager. Dark-first.
 * :root is dark (#0A0A0F). [data-theme="light"] overrides
 * to warm cream for Settings toggle.
 * Default: 'dark'. No attribute needed (CSS :root handles it).
 */

const STORAGE_KEY = 'fynwell_theme';

export function getTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'dark';
  } catch {
    return 'dark';
  }
}

export function setTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch { /* noop */ }
  applyTheme(theme);
}

export function applyTheme(theme) {
  if (theme === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    // Dark = default. Remove any stale attribute.
    document.documentElement.removeAttribute('data-theme');
  }
}

// Apply on load
applyTheme(getTheme());
